import {AfterViewInit, Component, OnDestroy, OnInit, Input, Output, EventEmitter} from "@angular/core";
import { Constant } from "../../constant";
import { EventManagerService } from '../../service/event-manager.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalBase } from "../modal.base.component";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
    selector: 'warning-popup',
    templateUrl: "./warning-popup.html",
    styleUrls: ["./warning-popup.scss"]
})

export class WarningPopupComponent extends ModalBase implements OnInit, OnDestroy {
    public Constant = Constant;
    @Output() result: EventEmitter<any> = new EventEmitter();
    @Input() iconImage: any = './assets/images/icons/warning.png';
    constructor(
        public eventManager: EventManagerService,
        public activeModal: NgbActiveModal,
        public ngModal: NgbModal
    ) {
        super(eventManager, activeModal);
    }
    argree() {
        this.dismiss();
        if (this.func) {
            this.func();
        } else this.result.emit(true);
    }
}
